import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { INewsListInterface } from '../interfaces/inews-list.interface';
import { environment } from '../../environments/environment';
import { INewsDetailInterface } from '../interfaces/inews-detail.interface';
import { ICommonResponse } from '../interfaces/icommon-response';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  API_NEWS_URL = environment.apiBaseUrl +  '/news/index';
  API_NEWS_DETAIL_URL = environment.apiBaseUrl + '/news/one-news';

  // Ссылки для рендеринга json ответа от ssr сервера
  JS_API_NEWS_URL = environment.jsApiBaseUrl + '/news/index';
  JS_API_NEWS_DETAIL_URL = environment.jsApiBaseUrl + '/news/one-news';

  constructor(private http: HttpClient) { }

  /**
   * Метод выполняет новый запрос на бэк за новостями (с updateRegistry).
   * */
  getNews(offset: number, limit: number, searchForm: { [key: string]: string | string[] }, sortParams?: any): Observable<ICommonResponse> {
    return this.http.post<INewsListInterface>(this.API_NEWS_URL, {
      offset,
      limit,
      searchForm,
      sortParams,
    });
  }

  getNewsById(id: string, isServer = false): Observable<INewsDetailInterface> {
    const url = isServer ? this.JS_API_NEWS_DETAIL_URL : this.API_NEWS_DETAIL_URL;
    return this.http.get<INewsDetailInterface>(`${url}/${id}`)
  }
}
